import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { pathToRegexp } from 'path-to-regexp';
import cloneDeepWith from 'lodash.clonedeepwith';

var preloadComponent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(Routes, config) {
    var baseName, pathName, _Routes, _loop, i;

    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            baseName = config && config.baseName;
            pathName = baseName ? location.pathname.replace(baseName, '') : location.pathname;
            _Routes = cloneDeepWith(Routes);
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop(i) {
              var _Routes$i, Component, path, activeComponent;

              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _Routes$i = _Routes[i], Component = _Routes$i.Component, path = _Routes$i.path;
                      activeComponent = Component();

                      if (!(activeComponent.preload && pathToRegexp(path).test(pathName))) {
                        _context.next = 6;
                        break;
                      }

                      _context.next = 5;
                      return activeComponent.preload();

                    case 5:
                      activeComponent = _context.sent.default;

                    case 6:
                      _Routes[i].Component = function () {
                        return activeComponent;
                      };

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop);
            });
            _context2.t0 = _regeneratorRuntime.keys(_Routes);

          case 5:
            if ((_context2.t1 = _context2.t0()).done) {
              _context2.next = 10;
              break;
            }

            i = _context2.t1.value;
            return _context2.delegateYield(_loop(i), "t2", 8);

          case 8:
            _context2.next = 5;
            break;

          case 10:
            return _context2.abrupt("return", _Routes);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee);
  }));

  return function preloadComponent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export { preloadComponent };